import {get as _get, find as _find, random as _random} from 'lodash';

import initialState from '../initialstate';
import {
	GET_PUBLISHED_VERSION_OPTIONS,
	GET_SENT_VERSION_OPTIONS,
	GET_PUBLISHED_VERSION_SNAPSHOT,
	GET_SENT_VERSION_SNAPSHOT
} from '../../actions/actiontypes';
import {HttpStatusCodes} from '../../util/uiconstants';
import normalizePublishedOptions from './normalizePublishedOptions';
import normalizeSentOptions from './normalizeSentOptions';
import normalizeSnapshot from './normalizeSnapshot';

export default function GSSnapshotsReducer(state = initialState.gsSnapshots, action) {
	const FAILED = _get(action, 'responseObj.status', null) !== HttpStatusCodes.Ok;
	switch (action.type) {
		case GET_PUBLISHED_VERSION_OPTIONS: {
			if (FAILED) return state;
			const data = _get(action, 'responseObj.data', []);
			return {
				...state,
				publishedOptions: normalizePublishedOptions(data)
			};
		}
		case GET_SENT_VERSION_OPTIONS: {
			if (FAILED) return state;
			const data = _get(action, 'responseObj.data', []);
			return {
				...state,
				sentOptions: normalizeSentOptions(data)
			};
		}
		case GET_PUBLISHED_VERSION_SNAPSHOT: {
			if (FAILED) return {...state, publishedSnapshot: null};
			const data = _get(action, 'responseObj.data', {});
			return {
				...state,
				publishedSnapshot: normalizeSnapshot(data),
				sentSnapshot: initialState.gsSnapshots.sentSnapshot,
				sentTeamId: initialState.gsSnapshots.sentTeamId
			};
		}
		case GET_SENT_VERSION_SNAPSHOT: {
			if (FAILED) return {...state, sentSnapshot: null};
			const data = _get(action, 'responseObj.data', {});
			const teamId = _get(action, 'teamId', null);
			return {...state, sentSnapshot: normalizeSnapshot(data), sentTeamId: teamId};
		}
		default:
			return state;
	}
}
